/**
 * Two-ring set panels.
 *
 * Two jobs, both small, because <details> already does the hard part:
 *
 *   1. EXCLUSIVITY. Opening one panel closes the other.
 *   2. THE HEADER VALUE. A closed panel has to say which size is selected
 *      inside it, so the summary is rewritten whenever that ring's radios
 *      change.
 *
 * WHAT THIS FILE DELIBERATELY DOES NOT DO: touch the selection, the variant,
 * the form, or the cart. The radios are ordinary inputs that the page's
 * existing variant logic already reads; closing a panel hides them and
 * changes nothing about what is checked. There is no state kept here.
 *
 * Exclusivity is done in script rather than with the native `name` attribute
 * on <details> because that is still too new to rely on — and where it IS
 * supported the browser and this file agree, so there is no conflict.
 */
(function () {
  "use strict";
  if (window.__calmySetSize) return;
  window.__calmySetSize = true;

  function panels(scope) {
    return Array.prototype.slice.call(
      (scope || document).querySelectorAll("[data-calmy-setpanel]")
    );
  }

  /* The word in front of the number ("Size 7") comes from what the server
     rendered, so a merchant renaming it in a locale is not undone here. */
  function labelWord(valEl) {
    var t = (valEl.getAttribute("data-word") || "").trim();
    if (t) return t;
    var first = (valEl.textContent || "").trim().split(/\s+/)[0] || "";
    valEl.setAttribute("data-word", first);
    return first;
  }

  function syncValue(panel) {
    var idx = panel.getAttribute("data-index");
    var out = panel.querySelector('[data-calmy-setval="' + idx + '"]');
    if (!out) return;
    var checked = panel.querySelector('input[data-calmy-opt="' + idx + '"]:checked');
    if (!checked) return;
    var word = labelWord(out);
    var next = (word ? word + " " : "") + checked.value;
    if (out.textContent !== next) out.textContent = next;
  }

  function init(scope) {
    var list = panels(scope);
    if (list.length < 2) {
      /* A single panel is not an accordion; still keep its header honest. */
      list.forEach(syncValue);
      return;
    }

    list.forEach(function (p) {
      if (p.__calmySetDone) return;
      p.__calmySetDone = true;

      syncValue(p);

      /* `toggle` rather than a click handler on the summary: it fires for the
         keyboard, for the native marker, and for any programmatic open, and it
         fires AFTER the state has changed so p.open is the truth. */
      p.addEventListener("toggle", function () {
        if (!p.open) return;
        panels().forEach(function (other) {
          if (other !== p && other.open) other.open = false;
        });
      });

      /* Any change inside this panel restates its header. Delegated, so the
         eight radios need no listeners of their own. */
      p.addEventListener("change", function () {
        syncValue(p);
      });
    });

    /* A variant change can arrive from outside these panels — the sticky bar
       mirrors selections, and the bundles app re-renders on its own. Restate
       both headers from whatever is checked whenever the form changes. */
    var form = list[0].closest("form") || document;
    if (!form.__calmySetFormBound) {
      form.__calmySetFormBound = true;
      form.addEventListener("change", function () {
        window.setTimeout(function () { panels().forEach(syncValue); }, 0);
      });
    }
  }

  function boot(scope) { init(scope); }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { boot(); });
  } else {
    boot();
  }
  document.addEventListener("shopify:section:load", function (e) { boot(e.target); });
})();
